/* NOURE landing pages - UTM retention + Pinterest Lead on confirmed submit.
 * 2026-08-04.
 *
 * UTM retention: reads only the five utm_* keys, stores them in sessionStorage,
 * and decorates same-origin CTA links that opt in via data-noure-utm. Never
 * touches canonical or Open Graph URLs. Never collects personal information.
 * Never sends data anywhere. Fails silently if storage is unavailable.
 *
 * Pinterest Lead: fires ONLY when Shopify has confirmed a successful signup.
 * Shopify's customer form posts and redirects back with ?form_type=customer&
 * customer_posted=true, and the template then renders .noure-lp__signup-success.
 * The event is bound to that server-confirmed state - NOT to page view, focus,
 * click, invalid input or failed submission. A sessionStorage guard prevents a
 * duplicate fire if the confirmation page is reloaded.
 */
(function () {
  'use strict';

  var KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  var STORE_KEY = 'noure_utm_v1';
  var LEAD_KEY = 'noure_lead_fired_v1';

  function getStore() { try { var r = sessionStorage.getItem(STORE_KEY); return r ? JSON.parse(r) : null; } catch (e) { return null; } }
  function setStore(o) { try { sessionStorage.setItem(STORE_KEY, JSON.stringify(o)); } catch (e) {} }

  function readFromUrl() {
    var found = {}, has = false;
    try {
      var p = new URLSearchParams(window.location.search);
      KEYS.forEach(function (k) { var v = p.get(k); if (v) { found[k] = String(v).slice(0, 150); has = true; } });
    } catch (e) { return null; }
    return has ? found : null;
  }

  function resolveUtms() { var u = readFromUrl(); if (u) { setStore(u); return u; } return getStore(); }

  function decorate(a, utms) {
    var href = a.getAttribute('href');
    if (!href || /^(#|mailto:|tel:|javascript:)/i.test(href)) return;
    var url; try { url = new URL(href, window.location.origin); } catch (e) { return; }
    if (url.origin !== window.location.origin) return;
    var changed = false;
    KEYS.forEach(function (k) {
      if (!utms[k] || url.searchParams.has(k)) return;
      url.searchParams.set(k, utms[k]); changed = true;
    });
    if (changed) a.setAttribute('href', url.pathname + url.search + url.hash);
  }

  function fireLeadIfConfirmed() {
    // Server-confirmed success only. The success block is rendered by Liquid from
    // form.posted_successfully?, so its presence means Shopify accepted the signup.
    var ok = document.querySelector('.noure-lp__signup-success');
    if (!ok) return;
    try { if (sessionStorage.getItem(LEAD_KEY)) return; } catch (e) {}
    if (typeof window.pintrk !== 'function') return;
    window.pintrk('track', 'lead', { lead_type: 'Newsletter' });
    try { sessionStorage.setItem(LEAD_KEY, '1'); } catch (e) {}
  }

  function init() {
    var roots = document.querySelectorAll('.noure-lp');
    if (!roots.length) return;
    var utms = resolveUtms();
    if (utms) {
      roots.forEach(function (root) {
        root.querySelectorAll('a[data-noure-utm]').forEach(function (a) { decorate(a, utms); });
      });
    }
    fireLeadIfConfirmed();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
